<template>
    <v-card outlined>
        <v-list-item single-line>
            <v-list-item-content>
                <div class="mb-1 title">{{data.name}}</div>
                <v-list-item-subtitle>{{data.address}}</v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-avatar
                rounded
                size="80"
            >
            <v-avatar color="grey lighten-1" v-if="this.data.avatar == undefined">
              <v-icon dark>
                mdi-account-circle
              </v-icon>
            </v-avatar>
            <v-avatar
              v-else
            >
              <v-img
                :src="this.getFullImageUrl(this.data)"
              ></v-img>
            </v-avatar>
            </v-list-item-avatar>
        </v-list-item>
        <v-card-actions>
            <v-btn
                tile
                color="primary"
                @click="editGuestWriter"
                title="Edit"
                class="mx-2" text
            >
                <v-icon>{{ icons.edit }}</v-icon>
            </v-btn>
            <v-btn
                tile
                color="primary"
                @click.stop="showDeleteDialog=true"
                title="Delete"
                class="mx-2" text
            >
                <v-icon>{{ icons.delete }}</v-icon>
            </v-btn>
             <v-btn
                tile
                color="primary"
                title="Article list"
                @click="articleList"
                class="mx-2" text
            >
                <v-icon>{{ icons.article }}</v-icon>
            </v-btn>
        </v-card-actions>
        <DeleteDialog :data="{id:data.id}" :visible="showDeleteDialog" @close="showDeleteDialog=false" @confirmAction="deletingImage"/>

    </v-card>
</template>
<script>
import DeleteDialog from '@/components/ConfirmDeleteDialog.vue'
import urlUtils from '@/utils/urlUtils'
import gwApi from '@/api/gwApi'
import snackbar from '@/utils/snackbar'
import { mdiPencil, mdiDelete, mdiClipboardListOutline } from '@mdi/js'

export default {
  components: {
    DeleteDialog
  },
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      icons: {
        edit: mdiPencil,
        delete: mdiDelete,
        article: mdiClipboardListOutline
      },
      showDeleteDialog: false,
      loading: false
    }
  },
  methods: {
    async articleList () {
      window.Vanglaini = {}
      window.Vanglaini.gwName = this.data.name
      this.$router.push({ path: '/guestwriter/' + this.data.id + '/articles' })
      // this.$router.push('/guestwriter/' + this.data.id + '/articles',query:{guestWriter:data.name})
    },
    async deletingImage (data) {
      if (data !== null && data.id !== undefined) {
        const id = data.id
        this.loading = true
        try {
          const result = await gwApi.deleteGuestWriter(id)
          if (result.data === 'success') {
            snackbar.show('Guest writer deleted successfully', 'success')
            this.$emit('delete_success')
          }
        } finally {
          this.loading = false
        }
      }
    },
    getFullImageUrl (gw) {
      if (gw.avatar !== null && gw.avatar !== undefined) {
        var k = urlUtils.getThumbnailUrl(gw.avatar.path)
        return k
      }
      return ''
    },
    editGuestWriter () {
      this.$router.push({ path: '/guestwriter/edit/' + this.data.id })
    }
  }
}
</script>
